// extracted by mini-css-extract-plugin
export default {"moreActions":"ActionBtn_moreActions__wIA7q","icon":"ActionBtn_icon__hEDM-","optionsList":"ActionBtn_optionsList__aYSBD"};